import * as React from "react";
//import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";

//import React, { useEffect, useState } from "react";
import useDeviceTye from "../../../../custom-hooks/DeviceType";
import Heading from "../../../../component-lib/Atoms/heading/EventEHRHeading";
import {
  CSV_HEADERS_VISIT_REPORTS,
  STATUS_FOR_TYPE_OF_VISIT_VISIT_REPORT,
  STATUS_FOR_UNSIGNED_SIGN_VISIT_REPORT,
  STATUS_FOR_VISIT_REPORT,
} from "../../ReportConstants";
import Table from "../../../../component-lib/Organisms/table/EventEHRTable";

import {
  destructStatusData,
  getSignBackground,
  getSignDotColor,
  getSignTextColor,
  getStatusBackground,
  getStatusDotColor,
  getStatusTextColor,
} from "../../../../utils/statusConstants";
import { useDispatch } from "react-redux";
import { plusIcon, searchIcon } from "../../../../assets";
import moment from "moment";
import { componentKey } from "../../ReportScreenSlice";
import { useSelector } from "react-redux";
import { TEXT_CONSTANTS } from "../../../../utils/text-constants/textConstants";

import Box from "@mui/material/Box";
import Button from "../../../../component-lib/Molecules/button/Button";
import Input from "../../../../component-lib/Atoms/Input/Input";
import SelectDropdown from "../../../../component-lib/Atoms/Select/Select";
import TooltipForTable from "../../../../component-lib/Molecules/tooltip/TooltipForTable";
import { visitReport } from "../../ReportScreenSaga";
import { getFacilities } from "../../../patient-screen/patientSaga";
import { componentKey as patientComponentKey } from "../../../patient-screen/patientSlice";
import DatePicker from "../../../../component-lib/Atoms/DatePicker/DatePicker";
import { CSVLink } from "react-csv";
import WrapperCard from "../../../../component-lib/Atoms/card/EventEHRWrapperCard";
import GetAppIcon from "@mui/icons-material/GetApp";
import EventEHRConfirmationDialog from "../../../../component-lib/Molecules/confimation-dialog/EventEHRConfirmationDialog";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

interface FullScreenVisitDialogProps {
  open: boolean;
  handleClose: () => void;
  selectedReport: string;
  visitFilterData: any;
  setVisitFilterData: any;
  isFilterVisible: any;
  setIsFilterVisible: any;
}

const FullScreenVisitDialog: React.FC<FullScreenVisitDialogProps> = ({
  open,
  handleClose,
  selectedReport,
  visitFilterData,
  setVisitFilterData,
  isFilterVisible,
  setIsFilterVisible,
}) => {
  const { visitReportData, allvisitReport } = useSelector(
    (state: any) => state[componentKey]
  );
  const { facilityData } = useSelector(
    (state: any) => state[patientComponentKey]
  );

  const deviceType = useDeviceTye();
  const dispatch = useDispatch();

  // Fetch the facility list for the Facility filter.
  React.useEffect(() => {
    dispatch(getFacilities());
  }, []);

  const facilityOptions = (facilityData ?? []).map((facility: any) => ({
    label: facility?.name,
    value: facility?.id,
  }));

  const adjustedGrid =
    deviceType === "tablet" || deviceType === "small-tablet"
      ? "1fr 1fr"
      : deviceType === "mobile"
        ? "1fr"
        : "1fr 1fr 1fr 1fr";

  const headerStyle = {
    fontWeight: "500",
    fontSize: "16px",
    paddingBottom: "10px",
  };

  const commonGridStyle = {
    gridTemplateColumns: adjustedGrid,
    padding: "0px 0px 12px 0px",
    display: "grid",
    gap: "24px 21px",
  };

  const [rowPerPage, setRowPerPage] = React.useState("10");
  const [pageNumber, setPageNumber] = React.useState(1);

  const [isFilterApplied, setIsFilterApplied] = React.useState({
    isTrue: false,
    filterData: {},
  });

  const [error, setError] = React.useState<any>("");

  const [openConfirmationDialog, setOpenConfirmationDialog] =
    React.useState(false);

  const [csvData, setCsvData] = React.useState<any[]>([]);

  const csvLinkRef = React.useRef<any>(null);

  // Auto-download the CSV only in response to a Download click — not when the
  // effect re-runs on mount against stale redux download data.
  const isDownloadClickedRef = React.useRef(false);

  const isFormFilled = Object.values(visitFilterData).some(
    (value) => value !== "" && value !== undefined
  );

  React.useEffect(() => {
    try {
      const payload = {
        pageNumber: pageNumber,
        limit: rowPerPage,
        isReport: true,
        ...isFilterApplied?.filterData,
      };

      dispatch(visitReport(payload));
    } catch (error) {
      console.log("error", error);
    }
  }, [rowPerPage, pageNumber, isFilterApplied?.filterData]);

  // Handle applying filter
  const handleApplyFilter = (values: any) => {
    setPageNumber(1);
    let hasError = false;

    const isFilteringByDateOnly = values?.startDate || values?.endDate;

    // Validation logic
    if (isFilteringByDateOnly) {
      if (!values?.startDate || !values?.endDate) {
        if (!values?.startDate && !values?.endDate) {
          setError("From Date and To Date are required.");
        } else if (!values?.startDate) {
          setError("From Date is required.");
        } else if (!values?.endDate) {
          setError("To Date is required.");
        }
        hasError = true;
      }
    }

    // Ensure endDate is greater than startDate
    if (!hasError && values?.endDate < values?.startDate) {
      setError("To Date should be greater than Start Date.");
      hasError = true;
    }

    if (hasError) return;

    setError(null);

    let updatePayload: any = {};

    // Send UTC ISO instants anchored to the user's local day so the backend
    // filters the correct calendar day regardless of server timezone.
    if (values?.startDate) {
      updatePayload.startDate = moment(values?.startDate)
        .startOf("day")
        .toISOString();
    }

    if (values?.endDate) {
      updatePayload.endDate = moment(values?.endDate).endOf("day").toISOString();
    }

    if (values.typeOfCare) {
      updatePayload.typeOfCare = values.typeOfCare;
    }

    if (values.type) {
      updatePayload.type = values.type;
    }

    if (values.status) {
      updatePayload.status = values.status;
    }

    if (values.sign) {
      updatePayload.sign = values.sign;
    }

    if (values?.facilityId) {
      updatePayload.facilityId = values.facilityId;
    }

    setIsFilterVisible(true);
    setIsFilterApplied({ isTrue: true, filterData: { ...updatePayload } });
  };

  const handleClearFilter = () => {
    setPageNumber(1);
    setIsFilterVisible(false);
    setIsFilterApplied({ isTrue: false, filterData: {} });
    setError("");
  };

  // VISIT TAB ROW DATA
  const visitTabRowData = visitReportData?.visit?.map((data: any) => {
    return {
      id: data?.id,
      patientName: `${data?.patient?.participant?.firstName || "-"} ${
        data?.patient?.participant?.lastName || ""
      }`,
      bsaId: data?.patient?.participant?.bsaId || "-",
      date: data?.updatedAt
        ? moment(data?.updatedAt)?.format("MM/DD/YYYY")
        : "-",
      type: data?.type === "WALK_In_Visit" ? "Walk In" : "EMS",
      status: data?.status ? data?.status : "-",
      chiefComplaint: data?.chiefComplaints,
      care: data?.typeOfCare ? data?.typeOfCare?.split("_")?.join(" ") : "-",
      care1Copy: data?.typeOfCare ? data?.typeOfCare : "-",
      baseCamp: data?.campName ? data?.campName : "-",
      facility:
        data?.patient?.facility?.name || data?.facilityName || "-",
      visitSigned: data?.visit_note?.some(
        (item: any) => item.isVisitSign === true
      ),
      visitNoteData: data?.visit_note,
    };
  });

  // VISIT TAB COLUMN DATA
  const patientVisitTabColumns = [
    {
      field: "patientName",
      label: <div>Patient Name</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.patientName}</p>
        );
      },
    },
    {
      field: "bsaId",
      label: <div>BSA ID</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.bsaId}</p>;
      },
    },
    {
      field: "Visit Date",
      label: <div>Visit Date</div>,
      renderLogic: (row: any) => {
        return (
          <p className=" text-primary-main font-normal font-weight-500">
            {row?.date}
          </p>
        );
      },
    },
    {
      field: "Visit Type",
      label: <div>Visit Type</div>,
      renderLogic: (row: any) => {
        return <p className=" text-neutral-90 font-normal">{row?.type}</p>;
      },
    },
    {
      field: "facility",
      label: <div>Facility</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.facility}</p>;
      },
    },
    // {
    //   field: "visitLocation",
    //   label: <div>Visit Location</div>,
    //   renderLogic: (row: any) => {
    //     return <p className="text-neutral-90 font-normal">{row?.baseCamp}</p>;
    //   },
    // },
    {
      field: "chiefComplaint",
      label: <div>Chief Complaint</div>,
      renderLogic: (row: any) => {
        return (
          <p
            className="text-neutral-90 cursor-pointer common-text-ellipse-style"
            onClick={() => {
              // navigate(`/patient/${row}`);
            }}
          >
            <TooltipForTable label={row?.chiefComplaint} />
          </p>
        );
      },
    },
    {
      field: "typeOfCare",
      label: <div>Type of Care</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.care}</p>;
      },
    },

    {
      field: "Status",
      label: <div>Status</div>,
      renderLogic: (row: any) => {
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <span
              className="font-weight-400 font-size-12px flex gap-1 items-center"
              style={{
                color: getStatusTextColor(row?.status),
                background: getStatusBackground(row?.status),
                borderRadius: "46px",
                padding: "4px 12px",
              }}
            >
              <span
                className="w-2 h-2"
                style={{
                  background: getStatusDotColor(row?.status),
                  borderRadius: "50%",
                }}
              ></span>
              {destructStatusData(row?.status)}
            </span>
          </div>
        );
      },
    },

    {
      field: "Signed/Unsigned",
      label: <div>Signed/Unsigned</div>,
      renderLogic: (row: any) => {
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <span
              className="font-weight-400 font-size-12px flex gap-1 items-center"
              style={{
                color: getSignTextColor(row?.visitSigned),
                background: getSignBackground(row?.visitSigned),
                borderRadius: "46px",
                padding: "4px 12px",
              }}
            >
              <span
                className="w-2 h-2"
                style={{
                  background: getSignDotColor(row?.visitSigned),
                  borderRadius: "50%",
                }}
              ></span>
              {row?.visitSigned ? "Signed" : "Unsigned"}
            </span>
          </div>
          // <p className="text-neutral-90 font-normal">
          //   {row?.visitSigned ? "Signed" : "Unsigned"}
          // </p>
        );
      },
    },
  ];

  const downloadHandler = (action: string) => {
    if (action === "close") {
      setOpenConfirmationDialog(false);
    } else if (action === "submit") {
      isDownloadClickedRef.current = true;
      dispatch(
        visitReport({
          limit: "All",
          isReport: true,
          ...isFilterApplied?.filterData,
        })
      );
    }
  };

  React.useEffect(() => {
    if (
      isDownloadClickedRef.current &&
      allvisitReport &&
      allvisitReport.visit?.length > 0
    ) {
      const formattedDataForVisitReport =
        allvisitReport?.visit?.map((data: any) => ({
          id: data?.id,
          patientName: `${data?.patient?.participant?.firstName || "-"} ${
            data?.patient?.participant?.lastName || ""
          }`,
          bsaId: data?.patient?.participant?.bsaId || "-",
          date: data?.updatedAt
            ? moment(data?.updatedAt)?.format("MM/DD/YYYY")
            : "-",
          type: data?.type === "WALK_In_Visit" ? "Walk In" : "EMS",
          status: data?.status ? data?.status : "-",
          chiefComplaint: data?.chiefComplaints,
          care: data?.typeOfCare
            ? data?.typeOfCare?.split("_")?.join(" ")
            : "-",
          care1Copy: data?.typeOfCare ? data?.typeOfCare : "-",
          baseCamp: data?.campName ? data?.campName : "-",
          facility:
            data?.patient?.facility?.name || data?.facilityName || "-",
          visitSigned: data?.visitSigned ? "Yes" : "No",
          visitNotes: Array.isArray(data?.visitNoteData)
            ? data?.visitNoteData.map((note: any) => note.text).join("; ")
            : "-", // Handle undefined visitNoteData
        })) ?? [];

      if (formattedDataForVisitReport.length > 0) {
        setCsvData(formattedDataForVisitReport);
        setTimeout(() => {
          csvLinkRef.current?.link.click();
        }, 500);
      }
      isDownloadClickedRef.current = false;
    }
  }, [allvisitReport]);

  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        sx={{
          backgroundColor: "white",
          minWidth: "200px",
          margin: "3px",
          marginTop: "50px",
          padding: "20px",
          height: "calc(100dvh - 97px)",
        }}
      >
        <AppBar sx={{ position: "relative", backgroundColor: "#005596" }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {selectedReport}
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box sx={{ p: 2, overflow: "auto" }}>
          {/* <p className="text-xl">
          Use the filters above to narrow down your results. Select one or more
          options to find exactly what you're looking for
        </p> */}
          <br />
          {/* //MAIN CODE */}

          <div>
            {/* //FILTER CODE */}
            <div
              style={{ border: "1px solid #D2D2D2" }}
              className="py-4 px-3 rounded mb-6"
            >
              <div className="w-full flex flex-col gap-6 rounded-lg">
                {/* PATIENT DETAILS */}
                <div>
                  <div className="flex justify-between mb-2">
                    <Heading title="Filter" customStyle={headerStyle} />
                    <div onClick={handleClose} className="cursor-pointer">
                      {" "}
                      {/* <CloseIcon /> */}
                    </div>
                  </div>
                  {/* //FILTER FIELDS FOR VISIT REPORT */}
                  <div style={commonGridStyle}>
                    <DatePicker
                      name={`From Date`}
                      value={visitFilterData?.startDate}
                      onChangeCb={(value) => {
                        setVisitFilterData((prevData: any) => ({
                          ...prevData,
                          startDate: value,
                        }));
                      }}
                      label="From Date"
                      style={{ width: "100%" }}
                      maxDate={moment()}
                    />
                    <DatePicker
                      name={visitFilterData?.endDate}
                      value={visitFilterData?.endDate}
                      onChangeCb={(value) => {
                        setVisitFilterData((prevData: any) => ({
                          ...prevData,
                          endDate: value,
                        }));
                      }}
                      label="To Date"
                      style={{ width: "100%" }}
                      maxDate={moment()}
                    />
                    <SelectDropdown
                      label="Visit Type"
                      placeholderValue="All Visit Type"
                      placeholderDisable={false}
                      name={"type"}
                      value={visitFilterData?.type}
                      options={STATUS_FOR_TYPE_OF_VISIT_VISIT_REPORT}
                      onChangeCb={(e) => {
                        const selectedValue = e.target.value;
                        setVisitFilterData((prevData: any) => ({
                          ...prevData,
                          type: selectedValue,
                        }));
                      }}
                    />

                    <SelectDropdown
                      placeholderValue="All Facilities"
                      placeholderDisable={false}
                      displayEmpty={true}
                      name={"facilityId"}
                      value={visitFilterData?.facilityId}
                      options={facilityOptions}
                      onChangeCb={(e) => {
                        setVisitFilterData((prevData: any) => ({
                          ...prevData,
                          facilityId: e.target.value,
                        }));
                      }}
                    />

                    <SelectDropdown
                      label="Unsigned/Sign Status"
                      placeholderValue="All Status"
                      placeholderDisable={false}
                      name={"unstatus"}
                      value={visitFilterData?.sign}
                      options={STATUS_FOR_UNSIGNED_SIGN_VISIT_REPORT}
                      onChangeCb={(e) => {
                        setVisitFilterData((prevData: any) => ({
                          ...prevData,
                          sign: e.target.value,
                        }));
                      }}
                    />
                    <SelectDropdown
                      placeholderValue="All Status"
                      placeholderDisable={false}
                      label="Visit Status"
                      name={"status"}
                      value={visitFilterData?.status}
                      options={STATUS_FOR_VISIT_REPORT}
                      onChangeCb={(e) => {
                        setVisitFilterData((prevData: any) => ({
                          ...prevData,
                          status: e.target.value,
                        }));
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="flex justify-end gap-4">
                {error && (
                  <p
                    style={{
                      color: "red",
                      marginTop: "9px",
                      marginRight: "auto",
                    }}
                  >
                    {error}
                  </p>
                )}
                {isFilterVisible && (
                  <Button
                    startIcon={<GetAppIcon />}
                    label="Download Reports"
                    variant="contained"
                    onClickCb={() => {
                      // Handle download logic here
                      downloadHandler("submit");
                    }}
                    style={{
                      width: "200px",
                      height: "40px",
                      marginTop: "3px",
                    }}
                  />
                )}

                <Button
                  label={TEXT_CONSTANTS?.CLEAR_ALL}
                  variant="outlined"
                  onClickCb={() => {
                    setVisitFilterData({
                      typeofCare: "",
                      // assignTo: "",
                      // assignBy: "",
                      type: "",
                      startDate: undefined,
                      endDate: undefined,
                      status: "",
                      sign: "",
                      facilityId: "",
                    });
                    // setDropdownData((prev) => ({
                    //   assignTo: { ...prev.assignTo, selectedValue: null },
                    //   assignBy: { ...prev.assignBy, selectedValue: null },
                    // }));
                    handleClearFilter();
                  }}
                  style={{
                    width: "120px",
                    height: "44px",
                    padding: "12px 20px",
                    fontSize: "16px",
                    backgroundColor: "white",
                    border: "none",
                    color: "#005596",
                  }}
                  //variant={undefined}        />
                />
                <Button
                  type="submit"
                  label={TEXT_CONSTANTS?.APPLY}
                  variant={isFormFilled ? "outlined" : "contained"}
                  disabled={!isFormFilled}
                  onClickCb={() => {
                    handleApplyFilter(visitFilterData);
                  }}
                  style={{
                    background: isFormFilled ? "#E4F3FF" : "",
                    color: isFormFilled ? "#005596" : "",
                    width: "120px",
                    height: "44px",
                    padding: "12px 20px",
                    fontSize: "16px",
                  }}
                ></Button>
              </div>
            </div>
            {isFilterVisible && (
              <div>
                <Table
                  columns={patientVisitTabColumns}
                  rows={visitTabRowData}
                  paginationProps={{
                    isPagination: true,
                    page: pageNumber,
                    totalPages: visitReportData?.totalPages,
                    totalCount: visitReportData?.total,
                    limit: rowPerPage,
                    rowsPerPageOptions: [10, 25, 50],
                    onPageChange: (page: any) => {
                      setPageNumber(page);
                    },
                    handleChangeRowsPerPage: (rowPerPage: any) => {
                      setRowPerPage(rowPerPage);
                      setPageNumber(1);
                    },
                  }}
                  noDataFoundMessage={"No tasks found"}
                />
              </div>
            )}
          </div>
        </Box>
      </Dialog>
      {
        <CSVLink
          data={csvData}
          headers={CSV_HEADERS_VISIT_REPORTS}
          ref={csvLinkRef}
          style={{ display: "none" }}
        />
      }
    </>
  );
};

export default FullScreenVisitDialog;
